import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton } from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import Iconify from '../../../components/iconify';
//
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import NotificationsPopover from './NotificationsPopover';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;
const NAV_COLLAPSED_WIDTH = 88;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isNavCollapsed',
})(({ theme, isNavCollapsed }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${(isNavCollapsed ? NAV_COLLAPSED_WIDTH : NAV_WIDTH) + 1}px)`,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  isNavCollapsed: PropTypes.bool,
  toggleNavCollapse: PropTypes.func,
  toggleDrawer: PropTypes.func,
};

export default function Header({ toggleDrawer, toggleNavCollapse, isNavCollapsed }) {
  return (
    <StyledRoot isNavCollapsed={isNavCollapsed}>
      <StyledToolbar>
        <IconButton
          onClick={toggleDrawer}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'none' },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>
        <IconButton
          onClick={toggleNavCollapse}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { xs: 'none', lg: 'inline-flex' },
          }}
        >
          <Iconify icon={isNavCollapsed ? 'eva:arrow-ios-forward-fill' : 'eva:arrow-ios-back-fill'} />
        </IconButton>

        <Searchbar />
        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          {// <LanguagePopover />
          }
          <AccountPopover />
          <NotificationsPopover />
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
